import { ByteSizeUnit, formatBytes } from '@frameio/utils/formatters';

export const getProjectStorage = (storageCount?: number) =>
  storageCount
    ? formatBytes(storageCount)
    : formatBytes(0, { bytesUnit: ByteSizeUnit.Megabyte });
